module.exports = __webpack_public_path__ + "img/p2.a00ae5ca.jpg";